import { render } from "./ProductItem.vue?vue&type=template&id=9176b158&scoped=true"
import script from "./ProductItem.vue?vue&type=script&lang=ts"
export * from "./ProductItem.vue?vue&type=script&lang=ts"

import "./ProductItem.vue?vue&type=style&index=0&id=9176b158&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9176b158"

export default script